module.exports = __webpack_public_path__ + "static/media/mom1.8a2c0139.jpg";